import { Button, DialogActions } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import './CancelDialog.css';
import { onClickConfirmDeleteProject } from './handler/ProjectManagementHandler';
import trI18n from '@/common/utils/trI18n';
import { tr } from '@/common/utils/tr';
import { useTranslationSubscription } from '@/hooks/useTranslation';

export default function DeleteProjectManagementDialog({ argsAll }) {
    // Re-render when the translation dictionary loads/extends so tr() text updates.
    useTranslationSubscription();

    const onCloseDialogReject = (event, reason) => {
        argsAll.setIsOpenConfirmDelete(false);
    };

    return (
        <Dialog
            open={argsAll.isOpenConfirmDelete}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="wrapDialog"
        >
            <DialogContent>
                <div className="confirmPlease">
                    {!argsAll.isProjectCanDelete
                        ? trI18n('USER03MSG004')
                        : trI18n('USER03MSG003')}
                </div>
            </DialogContent>
            <DialogActions className="confirm-dialog-action">
                {!argsAll.isProjectCanDelete ? (
                    <Button
                        variant="contained"
                        className="btn-hg32 btn-handle-delete-user-agree"
                        onClick={onCloseDialogReject}
                    >
                        {tr('閉じる')}
                    </Button>
                ) : (
                    <>
                        <Button
                            onClick={() =>
                                onClickConfirmDeleteProject(argsAll, argsAll.deleteProject)
                            }
                            variant="contained"
                            className="btn-hg32 btn-handle-delete-user-agree"
                        >
                            {trI18n('COMBTN002')}
                        </Button>

                        <Button
                            variant="contained"
                            className="btn-light btn-hg32"
                            onClick={onCloseDialogReject}
                        >
                            {trI18n('COMBTN007')}
                        </Button>
                    </>
                )}
            </DialogActions>
        </Dialog>
    );
}
